import { integrationTypeSchema } from '../../accounts/schemas/integration-type.schema';
import { z } from 'zod/v4';

export const partnerSchema = z.object({
  partnerId: z.string().min(1),
  partnerName: z.string().min(1),
  integrationType: integrationTypeSchema,
});

export type Partner = z.infer<typeof partnerSchema>;
